import Nullstack from 'nullstack';
export default function IconBrandHbo({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-hbo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 16v-8"
  }), "   ", Nullstack.element("path", {
    d: "M6 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M2 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M9 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
  }), "   ", Nullstack.element("path", {
    d: "M19 8a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "12",
    r: "1"
  }), " ");
}